import { BatchProcessesReadmodelType } from '@bett3r-dev/teselly-domain';
/**
 * Batch Processes List State
 *
 * Manages the paginated history of completed/canceled batch processes.
 * Active processes are managed by the shared store.
 */

export type BatchProcessesListState = {
  /** Completed + canceled batch processes */
  historyProcesses: BatchProcessesReadmodelType[];

  /** Total count of history processes (for pagination) */
  historyCount: number;

  /** Current page number (1-based) */
  currentPage: number;

  /** Processes per page */
  perPage: number;

  /** Loading states */
  loading: {
    history: boolean;
  };
};

export const initialState: BatchProcessesListState = {
  historyProcesses: [],
  historyCount: 0,
  currentPage: 1,
  perPage: 10,
  loading: {
    history: true
  }
};

/**
 * Derived state selectors
 */
export const selectors = {
  totalHistoryPages: ( state: BatchProcessesListState ): number =>
    Math.max( Math.ceil( state.historyCount / state.perPage ), 1 )
};
